// L'API Talkizy renvoie des messages d'erreur techniques en anglais :
// côté formateur, tout doit s'afficher en français. Les messages connus sont
// traduits (avec leur contexte : limites du plan), les inconnus retombent sur
// le fallback fourni par l'appelant — jamais d'anglais à l'écran.
const MESSAGES = {
  'Participants exceed plan limit': (data) => (data.max_participants
    ? `Votre forfait actuel est limité à ${data.max_participants} participants.`
    : 'Le nombre de participants dépasse la limite de votre forfait actuel.'),
  'Duration exceeds plan limit': (data) => (data.max_duration
    ? `La durée dépasse la limite de votre forfait actuel (${data.max_duration} minutes maximum).`
    : 'La durée dépasse la limite de votre forfait actuel.'),
  'Simultaneous meetings limit reached': (data) => (data.max_simultaneous
    ? `Votre forfait actuel ne permet pas plus de ${data.max_simultaneous} classe(s) virtuelle(s) en même temps sur ce créneau. Rendez-vous sur Talkizy pour en savoir plus.`
    : 'Vous avez atteint le nombre maximum de classes virtuelles simultanées de votre forfait actuel. Rendez-vous sur Talkizy pour en savoir plus.'),
  'Signature limit reached': (data) => (data.max_signature
    ? `Votre forfait actuel ne permet d'activer l'émargement que sur ${data.max_signature} classe(s) virtuelle(s). Désactivez-le sur une autre ou passez à une offre supérieure.`
    : 'Vous avez atteint le nombre maximum de classes virtuelles avec émargement de votre forfait actuel.'),
  'Cannot update a meeting that has already ended':
    () => 'Impossible de modifier une classe virtuelle terminée.',
  'Cannot add participants to a meeting that has already ended':
    () => 'Impossible d\'ajouter des participants à une classe virtuelle terminée.',
  'Cannot cancel a meeting in progress':
    () => 'Impossible d\'annuler une classe virtuelle en cours.',
  'Cannot cancel a meeting that has already ended':
    () => 'Impossible d\'annuler une classe virtuelle terminée.',
  'Cannot switch team with active meetings':
    () => 'Impossible de changer d\'espace : des classes virtuelles sont en cours ou à venir.',
  'Meeting not found': () => 'Classe virtuelle introuvable.',
  'Meeting creation failed': () => 'La création de la classe virtuelle a échoué.',
  'User not found or no team associated':
    () => 'Compte Talkizy introuvable. Reconnectez votre espace depuis les paramètres des classes virtuelles.',
  'No team associated with user':
    () => 'Compte Talkizy introuvable. Reconnectez votre espace depuis les paramètres des classes virtuelles.',
  // Déjà en français (émis par le proxy Teachizy) : conservé tel quel.
  'Espace non connecté à Talkizy': () => 'Espace non connecté à Talkizy.',
};

export default function talkizyErrorMessage(error, fallback) {
  const data = error?.response?.data || {};
  const mapper = data.error && MESSAGES[data.error];

  return mapper ? mapper(data) : fallback;
}
